import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { handleDecimalInput } from '../../CommonFunctions/CommonFunctions';

const InputPositiveNumber = ({
  value,
  updateValue,
  disabled,
  fromFormats,
  width,
  selectedMeasure,
  iconColor,
  backgroundColor,
}: {
  value: any;
  updateValue: any;
  disabled?: boolean;
  fromFormats?: boolean;
  width?: string;
  selectedMeasure?: any;
  iconColor?: string;
  backgroundColor?: string;
}) => {
  const [inputValue, setInputValue] = useState<any>(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    if (fromFormats && selectedMeasure) setInputValue(value);
    //eslint-disable-next-line
  }, [selectedMeasure]);

  return (
    <TextField
      className="inputValue"
      sx={{
        width: width ? width : '100%',
        marginRight: '0.2rem',
        '&.MuiFormControl-root': {
          backgroundColor: backgroundColor
            ? `${backgroundColor} !important`
            : 'transparent !important',
        },
        backgroundColor: backgroundColor || 'transparent',
        '& .MuiOutlinedInput-root': {
          height: '24px',
          fontSize: '13px',
          '& fieldset': {
            border: `1px solid ${iconColor ? iconColor : 'rgb(211, 211, 211)'}`,
          },
          '&:hover fieldset': {
            border: '1px solid #2bb9bb',
          },
          '&.Mui-focused fieldset': {
            border: '1px solid #2bb9bb',
          },
          '&.Mui-disabled': {
            '& fieldset': {
              border: `1px solid ${iconColor ? iconColor : 'rgb(211, 211, 211)'} !important`,
            },
            backgroundColor: backgroundColor || 'transparent',
          },
        },
        '& .MuiOutlinedInput-input': {
          padding: width ? '8px' : '0 8px',
          color: iconColor || 'rgb(128, 128, 128)',
          '-webkit-text-fill-color': `${iconColor || 'rgb(128, 128, 128)'} !important`,
        },
        '& .MuiOutlinedInput-input.Mui-disabled': {
          color: `${iconColor || 'rgb(128, 128, 128)'} !important`,
          '-webkit-text-fill-color': `${iconColor || 'rgb(128, 128, 128)'} !important`,
          backgroundColor: backgroundColor || 'transparent',
        },
      }}
      // onBlur={() => checkInput()}
      InputProps={{
        style: {
          height: '1.5rem',
          lineHeight: '1rem',
          width: '100%',
          outline: 'none',
          color: iconColor ? iconColor : 'rgb(128, 128, 128)',
          backgroundColor: backgroundColor || 'transparent',
        },
      }}
      type="number"
      inputProps={{ step: 'any', 'arial-label': 'Enter a decimal number' }}
      value={inputValue}
      onChange={(e) => {
        const value = e.target.value;
        let isDecimalInput = handleDecimalInput(value);
        if (isDecimalInput) {
          if (Number(value) >= 0) {
            updateValue(Number(value));
            setInputValue(value);
            if (fromFormats && Number(value) > 4) {
              updateValue(4);
              setInputValue(4);
            }
          } else {
            updateValue(0);
            setInputValue('0');
          }
        }
      }}
      disabled={disabled}
    />
  );
};

export default InputPositiveNumber;
